module.exports = __webpack_public_path__ + "img/honor_3.a4661391.png";